export const hardReload = () => {
    window.location.reload();
}